
(function () {
  if (window.__JNCardInit) return;
  window.__JNCardInit = true;

  // -------------------- CACHES --------------------
  const PRODUCT_JSON = new Map();      // handle -> Promise<Product>
  const WARMED = new Set();            // warmed image URLs
  const WIDTH_CACHE = new Map();   // card -> px width
  const IN_FLIGHT = new WeakMap();     // card -> AbortController
  //const money = (c) => { try { return Shopify.formatMoney(c, window.theme?.moneyFormat || "${{amount}}"); } catch { return `$${(c/100).toFixed(2)}`; } };

  // -------------------- HELPERS -------------------
  function measureCardWidth(card) {
    let w = WIDTH_CACHE.get(card);
    if (!w) {
      const primary = card.querySelector('.product-card__image--primary') || card.querySelector('img');
      w = Math.ceil(((primary?.getBoundingClientRect().width) || 360) * (window.devicePixelRatio || 1));
      WIDTH_CACHE.set(card, w);
    }
    return Math.min(Math.max(w, 320), 1600);
  }

  function sizeUrl(rawUrl, card) {
    if (!rawUrl) return rawUrl;
    try {
      const u = new URL(rawUrl, location.origin); // supports absolute and //-relative
      if (!u.searchParams.has('width')) u.searchParams.set('width', String(measureCardWidth(card)));
      return u.toString();
    } catch { return rawUrl; }
  }

  function warmImage(url) {
    if (!url || WARMED.has(url)) return;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.loading = 'eager';
    img.src = url;
    WARMED.add(url);
  }

  async function getProductJSON(handle, signal) {
    let p = PRODUCT_JSON.get(handle);
    if (!p) {
      p = fetch(`/products/${handle}.js`, { signal, credentials: 'same-origin' })
            .then(r => { if (!r.ok) throw new Error(`JSON ${handle}`); return r.json(); });
      PRODUCT_JSON.set(handle, p);
    }
    return p;
  }

  function hardSwapImg(imgEl, url) {
    if (!imgEl || !url) return imgEl;
    const clone = imgEl.cloneNode(true);
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.setAttribute('crossorigin', 'anonymous');
    clone.loading = 'eager';
    clone.decoding = 'async';
    clone.src = url;
    imgEl.replaceWith(clone);
    return clone;
  }

  function getPrimaryImg(mediaLink) {
    return mediaLink.querySelector('.product-card__image--primary') || mediaLink.querySelector('img');
  }

  function ensureSecondaryImg(mediaLink, primaryImg) {
    let secondary = mediaLink.querySelector('.product-card__image--secondary');
    if (!secondary) {
      secondary = primaryImg.cloneNode(true);
      secondary.classList.remove('product-card__image--primary');
      secondary.classList.add('product-card__image--secondary');
      secondary.removeAttribute('src');
      secondary.removeAttribute('srcset');
      secondary.removeAttribute('sizes');
      secondary.style.visibility = 'hidden';
      mediaLink.appendChild(secondary);
    }
    return secondary;
  }

  // multi currency helpers
  let __pat;
  const formatCents = (c, trim=true) => {
    if (!__pat) { __pat = (() => {
      const n = document.querySelector('sale-price'); // probe once
      if (!n) return { pre:'', suf:'', dec:'.' };
      const x = n.cloneNode(true);
      x.querySelectorAll('.sr-only,.visually-hidden').forEach(e=>e.remove());
      const t = x.textContent.trim();
      const m = t.match(/^(.*?)([\d.,\u00A0\u202F\s]+)(.*?)$/) || [, '', '', ''];
      const dec = (m[2].match(/([.,])\d{1,3}\s*$/)||[])[1] || '.';
      return { pre:m[1], suf:m[3], dec };
    })(); }
    const v = Math.abs(c||0)/100, neg = (c||0) < 0;
    const fd = trim && Math.round(v*100)%100===0 ? 0 : 2;
    const num = new Intl.NumberFormat(__pat.dec===',' ? 'de-DE' : 'en-US',
      { minimumFractionDigits: fd, maximumFractionDigits: fd }).format(v);
    return (neg?'-':'') + __pat.pre + num + __pat.suf;
  };

  function fmt(cents) {
    return formatCents(cents);
  }


  function setPrice(priceListEl, variant) {
    if (!priceListEl || !variant) return;
    const price = Number(variant.price);
    const compare = Number(variant.compare_at_price || 0);
    priceListEl.innerHTML = compare && compare > price
      ? `<sale-price class="text-on-sale"><span class="sr-only">Sale price</span>${fmt(price)}</sale-price><compare-at-price class="text-subdued line-through"><span class="sr-only">Regular price</span>${fmt(compare)}</compare-at-price>`
      : `<sale-price class="text-subdued"><span class="sr-only">Price</span>${fmt(price)}</sale-price>`;
  }

  function setLinks(card, url) {
    const mediaLink = card.querySelector('.product-card__media');
    const titleLink = card.querySelector('.product-title');
    if (mediaLink) mediaLink.href = url;
    if (titleLink) titleLink.href = url;
    const handle = url.split('/').pop();
    if (handle) card.setAttribute('handle', handle);
  }

  const getQuickModal = (card) =>
    card.querySelector('quick-buy-modal') || document.querySelector('quick-buy-modal');

  function setQuickView(card, handle, variantId, canonical) {
    const modal = getQuickModal(card);
    if (!modal) return;
    const value = variantId ? `${handle}?variant=${variantId}` : handle;
    modal.setAttribute('handle', value);
    if (canonical) modal.setAttribute('data-canonical', canonical);
  }

  // -------------------- SWATCH CHANGE -------------------
  document.addEventListener('change', async (ev) => {
    const t = ev.target;
    if (!(t instanceof Element)) return;

    const input = t.closest('input.js-sibling-swatch[type="radio"]');
    if (!input) return;

    const card = input.closest('product-card, .product-card');
    if (!card) return;

    const media = card.querySelector('.product-card__media');
    if (!media) return;

    let primary   = getPrimaryImg(media);
    let secondary = media.querySelector('.product-card__image--secondary');
    const priceEl = card.querySelector('price-list');
    const wishlistEl = card.querySelector('.smartwishlist');

    const url     = input.dataset.url;
    const handle  = input.dataset.handle;
    const prefer  = input.dataset.preloadUrl || input.dataset.image || '';
    

    // 1) Update links immediately
    setLinks(card, url);

    // 2) Optimistic primary swap (instant)
    const firstUrl = sizeUrl(prefer, card);
    if (firstUrl) {
      warmImage(firstUrl);
      primary = hardSwapImg(primary, firstUrl);
    }

    // 3) Cancel any prior fetch for this card, then fetch JSON
    const prev = IN_FLIGHT.get(card);
    if (prev && typeof prev.abort === 'function') prev.abort();
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    IN_FLIGHT.set(card, controller);

    try {
      const product = await getProductJSON(handle, controller?.signal);
      if (IN_FLIGHT.get(card) !== controller) return;

      const variant = product.variants.find(v => v.available) || product.variants[0] || null;
      setPrice(priceEl, variant);

      const primaryJSON  = sizeUrl(product.images?.[0], card);
      const secondaryJSON = sizeUrl(product.images?.[1], card);

      if (primaryJSON) primary = hardSwapImg(primary, primaryJSON);

      if (secondaryJSON) {
        secondary = ensureSecondaryImg(media, primary);
        warmImage(secondaryJSON);
        secondary = hardSwapImg(secondary, secondaryJSON);
        secondary.style.visibility = '';
        media.classList.add('has-secondary');  // harmless if theme ignores it
      } else if (secondary) {
        secondary.removeAttribute('src');
        secondary.style.visibility = 'hidden';
        media.classList.remove('has-secondary');
      }

      const canonical = input.dataset.canonical || card.getAttribute('data-canonical') || '';
      setQuickView(card, handle, variant && variant.id, canonical);
      if( wishlistEl && product ) {
        const clone = wishlistEl.cloneNode(true);
        clone.removeAttribute('class');
        clone.removeAttribute('title');
        clone.removeAttribute('aria-label');
        clone.removeAttribute('role');
        clone.dataset.product = String(product.id);
        clone.dataset.variant = variant ? String(variant.id) : "";
        clone.setAttribute('data-product', clone.dataset.product);
        clone.setAttribute('data-variant', clone.dataset.variant);
        clone.setAttribute('class', 'smartwishlist');
        wishlistEl.replaceWith(clone); 
        if (typeof window.ReloadSmartWishlist === 'function') window.ReloadSmartWishlist();
      }
    } catch(e) {
      console.log(e);
      setQuickView(card, handle, null, (input.dataset.canonical || card.getAttribute('data-canonical') || ''));
    } finally {
      if (IN_FLIGHT.get(card) === controller) IN_FLIGHT.delete(card);
    }
  });

  // -------------------- PRELOAD (approach + hover) -------------------
  const MAX_PRELOAD = 3; // selected + 2

  async function warmInput(card, input) {
    let raw = input.dataset.image;
    if (!raw) {
      try { const p = await getProductJSON(input.dataset.handle); raw = (p.images && p.images[0]) || ''; }
      catch {}
    }
    const u = sizeUrl(raw, card);
    input.dataset.preloadUrl = u;
    warmImage(u);

    // warm secondary if JSON is already cached
    try {
      const p = await PRODUCT_JSON.get(input.dataset.handle);
      const raw2 = p && p.images && p.images[1];
      if (raw2) warmImage(sizeUrl(raw2, card));
    } catch {}
  }

  function warmCard(card) {
    const inputs = Array.from(card.querySelectorAll('input.js-sibling-swatch'));
    if (!inputs.length) return;
    const selected = inputs.find(i => i.checked) || inputs[0];
    const rest = inputs.filter(i => i !== selected);
    const candidates = [selected, ...rest].slice(0, MAX_PRELOAD);
    candidates.forEach(i => warmInput(card, i));
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { warmCard(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '1000px 0px' });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-card, .product-card').forEach(card => io.observe(card));
  });

  document.addEventListener('mouseover', (ev) => {
    const el = ev.target;
    if (!(el instanceof Element)) return;
    const label = el.closest('label.color-swatch');
    if (!label) return;
    const card  = label.closest('product-card, .product-card');
    if (!card) return;
    const inputId = label.getAttribute('for');
    const input = inputId && document.getElementById(inputId);
    if (!input) return;
    if (!input.dataset.prewarmed) { warmInput(card, input); input.dataset.prewarmed = '1'; }
  }, { passive: true });

  // Recompute size cache on resize (deferred)
  let rAF;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(() => WIDTH_CACHE.clear());
  });
})();

/* wishlist reload on filter change (plp) */
(function smartWishlistAfterFilters(){
  const canReload = () => typeof window.ReloadSmartWishlist === 'function';

  let pending = false;
  function scheduleReload(){
    if (!canReload()) return;
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; window.ReloadSmartWishlist(); });
  }

  // Observe grid replacements (Prestige/S&D will swap these containers)
  const gridSelectors = [
    '.product-list'
  ].join(',');

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches?.('span.smartwishlist')) { scheduleReload(); return; }
        if (n.matches?.(gridSelectors) || n.querySelector?.('span.smartwishlist')) { scheduleReload(); return; }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Also react to filter UI interactions (submit/change) and pagination
  document.addEventListener('change', (e) => {
    if (e.target.closest('facet-filters-form, [data-filters], form[action*="/collections/"], form[action*="/search"]')) {
      setTimeout(scheduleReload, 400);
    }
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('.Pagination, [data-load-more], [data-infinite-scroll], a[href*="page="]')) {
      setTimeout(scheduleReload, 400);
    }
  });

  // Initial bind
  if (document.readyState !== 'loading') scheduleReload();
  else document.addEventListener('DOMContentLoaded', scheduleReload);
})();